import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconListCheck32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconListCheck32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.389 8.646a1 1 0 0 0-1.414-1.414l-3.536 3.536-1.414-1.414a1 1 0 1 0-1.414 1.414l2.121 2.121.707.707.707-.707zM28 9a1 1 0 1 0 0-2H15a1 1 0 1 0 0 2zm0 10a1 1 0 1 0 0-2H15a1 1 0 1 0 0 2zm-1-6a1 1 0 0 1-1 1H15a1 1 0 1 1 0-2h11a1 1 0 0 1 1 1m-1 11a1 1 0 1 0 0-2H15a1 1 0 1 0 0 2zM9 18H5v4h4zm-4-2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconListCheck32);
